import { useEffect, useState } from "react";
import { getTopicById } from "../utils/userManual";

const useApiContent = ({ baseUrl, topicId, lang = "en-US", variant = "A" }) => {
  const [data, setData] = useState({});

  useEffect(() => {
    const fetchReleaseNotes = async () => {
      try {
        const apiUrl = `${baseUrl}/variants/${variant}/languages/${lang}/files`;

        // fetch topics from manifest.json
        const manifestResponse = await fetch(`${apiUrl}/manifest.json`);
        const { topics } = await manifestResponse.json();
        // get data by topic id in manifest.json
        const { title, content } = getTopicById(topics, topicId);

        // fetch content file which contains markup
        const releasNotesResponse = await fetch(`${apiUrl}/${content}`);
        // convert xml to markup string
        const html = await releasNotesResponse.text();

        // console.log("MARKUP", title, html);

        setData({
          title,
          html
        });
      } catch (error) {
        console.error("failed to fetch release notes", error);
      }
    };

    fetchReleaseNotes();
  }, [baseUrl, topicId, lang, variant]);

  return { ...data };
};

export default useApiContent;
